export const WITH_CATEGORY_PAGE_TITLE = 'APPs By Activity Category'
export const WITHOUT_CATEGORY_PAGE_TITLE = 'APPs Without Activity Category'

export const PAGE_TYPE_WITH_CATEGORY = 'category_page'
export const PAGE_TYPE_WITHOUT_CATEGORY = 'without_category_page'
